import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePromotePageState } from 'src/app/pages/promote/pageContext';
import type { PaymentType } from 'src/app/shared/utils/payments';

import { useTracking } from '../useTracking';

export function useOnTokenInvalid(): (paymentType: PaymentType, err: Error) => void {
	const [, { clearLoading }] = usePromotePageState();
	const { trackSubmitInvalid } = useTracking();
	const { errorReporter } = useUtilityContext();

	return function onTokenInvalid(paymentType: PaymentType, err: Error): void {
		clearLoading();
		trackSubmitInvalid({ paymentType, errorMessage: err.message });
		void errorReporter.report(
			{
				error: new Error('Payment failed due to invalid token', { cause: err }),
				params: { paymentType },
			},
			{
				severity: 'warning',
			},
		);
	};
}
